import { render, staticRenderFns } from "./ButtonDiningOutRestaurant.vue?vue&type=template&id=446985e4&scoped=true"
import script from "./ButtonDiningOutRestaurant.vue?vue&type=script&lang=js"
export * from "./ButtonDiningOutRestaurant.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "446985e4",
  null
  
)

export default component.exports